import Collection from 'collection/collection'
import CommunityModel from 'model/community'

const Communities = Collection.extend({
    model: CommunityModel,
})

export default Communities
